import * as actionTypes from "../actions/actionTypes";

const initialState = {
  cart: {
    campaignRateCC: null,
    campaignRateCollection: null,
    isInvoice: false,
    idOrder: undefined,
    descriptionSuccess: "",
    orderDeliveryDate: undefined,
    checkout: false,
    showPlacedModal: false,
    showReceiptModal: false,
    products: [],
    restaurantSelected: null,
    subsidy: 0,
    subtotal: 0,
    total: 0,
    tipValue: 0,
    maxBasketCost: 0,
    cards: [],
    modalErrorPlacedOrder: false,
    errorLimit: "",
    payInfo: {},
    isButtonDisabled: false,
    discounts: {},
    deliveryTomorrow: false,
    restaurantCurrentIsOpen: true
  }
};

const cartReducer = (state = initialState, actions) => {

  let cartUpdate;
  switch (actions.type) {
    case actionTypes.TOGGLE_CART:
      cartUpdate = state.cart;

      cartUpdate.checkout =
        actions.status !== null ? actions.status : !cartUpdate.checkout;
      return {
        ...state,
        cart: cartUpdate
      };
    case actionTypes.ADD_PRODUCT_TO_CART:
      cartUpdate = state.cart;
      let productsUpdated;
      if (Array.isArray(actions.payload.product)) {
        productsUpdated = [...cartUpdate.products, ...actions.payload.product];
      } else {
        productsUpdated = [...cartUpdate.products, actions.payload.product];
      }
      cartUpdate.products = productsUpdated;
      if (
        JSON.stringify(cartUpdate.restaurantSelected) !==
        JSON.stringify(actions.payload.business)
      ) {
        cartUpdate.restaurantSelected = actions.payload.business;
        cartUpdate.campaignRateCC = null;
        cartUpdate.campaignRateCollection = null;
      }
      cartUpdate.checkout = true;

      return {
        ...state,
        cart: { ...state.cart, ...cartUpdate }
      };
    case actionTypes.DELETE_PRODUCT_FROM_CART:
      cartUpdate = state.cart;
      let productsUpdate = [...cartUpdate.products];
      let index = productsUpdate.findIndex(
        product => product.id === actions.payload.product.id
      );
      productsUpdate.splice(index, 1);
      cartUpdate.products = productsUpdate;
      cartUpdate.checkout = productsUpdate.length > 0 ? true : false;
      return {
        ...state,
        cart: cartUpdate
      };
    case actionTypes.DELETE_ALL_PRODUCTS_FROM_CART:
      cartUpdate = state.cart;
      cartUpdate.checkout = false;
      cartUpdate.products = [];
      cartUpdate.subsidy = 0;
      cartUpdate.tipValue = 0;
      return {
        ...state,
        cart: cartUpdate
      };
    case actionTypes.LOGOUT:
      cartUpdate = state.cart;
      cartUpdate.subtotal = 0;
      cartUpdate.tipValue = 0;
      cartUpdate.total = 0;
      cartUpdate.maxBasketCost = 0;
      cartUpdate.cards = [];
      cartUpdate.restaurantSelected = null;
      cartUpdate.checkout = false;
      cartUpdate.campaignRate = [];
      cartUpdate.products = [];
      cartUpdate.subsidy = 0;
      return {
        ...state,
        cart: cartUpdate
      };
    case actionTypes.CART_CALCULATED_VALUES:
      cartUpdate = state.cart;
      cartUpdate.subsidy = actions.subsidy;
      cartUpdate.total = actions.total;
      cartUpdate.tipValue = actions.tipValue;
      cartUpdate.maxBasketCost = actions.maxBasketCost;
      cartUpdate.discounts = actions.discounts;
      if (
        cartUpdate.campaignRateCollection &&
        cartUpdate.restaurantSelected.forCollection === "Y"
      ) {
        let discount =
          cartUpdate.campaignRateCollection.discountType === "P"
            ? cartUpdate.total *
            (cartUpdate.campaignRateCollection.amount / 100)
            : cartUpdate.campaignRateCollection.amount;
        cartUpdate.total = cartUpdate.total - discount;
      }

      cartUpdate.subtotal = actions.subtotal;
      return {
        ...state,
        cart: cartUpdate
      };
    case actionTypes.SUCCESS_FETCHING_CARDS:
      cartUpdate = state.cart;
      cartUpdate.cards = actions.cards;
      return {
        ...state,
        cart: cartUpdate
      };
    case actionTypes.SUCCESS_FETCHING_CAMPAIGN_RATE:
      cartUpdate = state.cart;
      cartUpdate.campaignRateCC = actions.campaignRate.find(item => {
        return (
          item.chargeType === "C" &&
          item.statusReg === "A" &&
          item.status === "E"
        );
      });
      cartUpdate.campaignRateCollection = actions.campaignRate.find(item => {
        return (
          item.chargeType === "T" &&
          item.statusReg === "A" &&
          item.status === "E"
        );
      });
      return {
        ...state,
        cart: cartUpdate
      };
    case actionTypes.TRIGGER_MODAL_ERROR_PLACED_ORDER:
      cartUpdate = state.cart;
      cartUpdate.modalErrorPlacedOrder = true;
      cartUpdate.errorLimit = actions.errorLimit;
      return {
        ...state,
        cart: cartUpdate
      };
    case actionTypes.CLOSE_MODAL_ERROR_PLACED_ORDER:
      cartUpdate = state.cart;
      cartUpdate.modalErrorPlacedOrder = false;
      return {
        ...state,
        cart: cartUpdate
      };
    case actionTypes.SUCCESS_PLACE_ORDER:
      cartUpdate = state.cart;
      cartUpdate.idOrder = actions.payload.idOrder;
      cartUpdate.orderDeliveryDate = actions.payload.orderDeliveryDate;
      cartUpdate.descriptionSuccess = actions.payload.descriptionSuccess;
      return {
        ...state,
        cart: cartUpdate
      };
    case actionTypes.CART_RESET_STATE:
      return {
        cart: {
          idOrder: undefined,
          orderDeliveryDate: undefined,
          descriptionSuccess: "",
          checkout: false,
          isInvoice: false,
          showPlacedModal: false,
          showReceiptModal: false,
          products: [],
          restaurantSelected: null,
          campaignRate: [],
          subsidy: 0,
          subtotal: 0,
          tipValue: 0,
          total: 0,
          maxBasketCost: 0,
          cards: [],
          modalErrorPlacedOrder: false,
          isButtonDisabled: false,
          errorLimit: "",
          deliveryTomorrow: false,
          restaurantCurrentIsOpen: true
        }
      };
    case actionTypes.CART_TOGGLE_SHOW_MODAL_PLACE_ORDER:
      return {
        ...state,
        cart: {
          ...state.cart,
          showPlacedModal: actions.payload
        }
      };
    case actionTypes.CART_TOGGLE_SHOW_MODAL_RECEIPT:
      return {
        ...state,
        cart: {
          ...state.cart,
          showReceiptModal: actions.payload
        }
      };
    case actionTypes.CART_SET_PLACED_BUTTON_DISABLED:
      return {
        ...state,
        cart: {
          ...state.cart,
          isButtonDisabled: actions.payload
        }
      };
    case actionTypes.CART_SET_PAY_INFO:
      return {
        ...state,
        cart: {
          ...state.cart,
          payInfo: actions.payload
        }
      };
    case actionTypes.CART_SET_INVOICE:
      return {
        ...state,
        cart: {
          ...state.cart,
          isInvoice: actions.payload
        }
      };
    case actionTypes.CART_DELIVERY_TOMORROW:
        return {
          ...state,
          cart: {
            ...state.cart,
            deliveryTomorrow: actions.payload
          }
        };
      case actionTypes.CART_UPDATED_RESTAURANT_STATUS:
        return {
          ...state,
          cart: {
            ...state.cart,
            restaurantCurrentIsOpen: actions.payload
          }
        };
    default:
      return state;
  }
};

export default cartReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/cartReducer.js